import {useState, useEffect} from 'react';
import {getPurchaseOrders} from "../../api/Api";
import {ExistingPurchaseOrderTable} from "./ExistingPurchaseOrderTable";
import {PurchaseOrderStatusType} from "../../api/Constants";

export const ExistingPurchaseOrder = ({session, onApiFail, refresh, onRefresh,  props}) => {
    const [purchaseOrders, setPurchaseOrders] = useState([]);

    useEffect(() => {
        getPurchaseOrders(PurchaseOrderStatusType.Complete, false).then(r => {
            let purchaseOrders = r;
            if (session !== undefined) {
                // if a session is passed in we want to filter by the user
                const {id} = session;
                purchaseOrders = purchaseOrders.filter(po => {
                    return po.userId === id;
                });
            }
            setPurchaseOrders(purchaseOrders);
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        })
    }, [session, onApiFail, refresh])


    const content = <ExistingPurchaseOrderTable items={purchaseOrders}  onRefresh={onRefresh} onApiFail={onApiFail}/>

    return content;
}